import { getCurrentSubscription } from "@syla/shared/types/subscriptions/getCurrentSubscription";
import { useCallback, useState } from "react";
import { getFullPageUrl } from "../../helper/getFullPageUrl";
import { useReportError } from "../../helpers/useReportError";
import { useCurrentAccountStore } from "../../store/currentAccountStore";
import { useGlobalVariablesStore } from "../../store/globalVariablesStore";
import { Plan } from "../../types/plans/plan";
import { Subscription } from "../../types/plans/subscription";
import { stripePurchaseOrUpgrade } from "../stripePurchaseOrUpgrade";

export function useUnlockPlanAction({
  subscriptions,
}: {
  subscriptions: Subscription[] | undefined;
}) {
  const errorToast = useReportError();
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);
  const [isWorking, setIsWorking] = useState(false);

  const currentSubscription = getCurrentSubscription(subscriptions);

  const selectedFinancialYear = useGlobalVariablesStore(
    (state) => state.selectedFinancialYear,
  );
  const unlockPlanAction = useCallback(
    async (plan: Plan) => {
      try {
        setIsWorking(true);
        await stripePurchaseOrUpgrade({
          accountId,
          successUrl: getFullPageUrl(location),
          financialYear: selectedFinancialYear?.value,
          currentSubscription,
          plan,
        });
      } catch (error) {
        errorToast(error);
        setIsWorking(false);
        return;
      }
    },
    [
      accountId,
      currentSubscription?.stripeSubscriptionId,
      errorToast,
      selectedFinancialYear?.value,
    ],
  );

  return {
    isWorking,
    unlockPlanAction,
  };
}
